import React, {useEffect, useMemo, useState} from 'react'
import LoadingBanner from '../../components/LoadingBanner'
import ProjectBiddingWizardStep from './BiddingWizardStep'
import BiddingProposalsStep from "./BiddingProposalsStep";
import BiddingContractStep from "./BiddingContractStep";
import BiddingCandidatesStep from "./BiddingCandidatesStep";

import BiddingBriefStep from "./BiddingBriefStep";
import ProposalRouteModal from "./components/ProposalRouteModal";
import ShareModal from "./components/ShareModal";
import {useProject} from "../../providers/ClientProjectProvider";
import {
    generatePath,
    Link,
    Navigate,
    Outlet,
    useLocation,
    useNavigate,
    useOutletContext,
    useParams,
} from "react-router-dom";
import {ProjectPositionProvider} from "../../providers/ProjectPositionProvider";
import {Affix} from "antd";
import {useIsFetching} from '@tanstack/react-query';
import InfoTooltip from "../../components/InfoTooltip";
import UserImageCircle from "../../components/UserImageCircle";
import {useAuth} from '../../providers/AuthProvider';
import PageNotFound from "../../components/errors/PageNotFound";
import ProposalFooter from './components/ProposalFooter';
import BulkActionsContainer from "../client-lead-tools/BulkActionsContainer";


const TeamListTypes = {
    All: 'All Teams',
    Liked: 'Liked',
    Favorite: 'Favorite',
    Archive: 'Archived',
};
const TalentListTypes = {
    All: 'All Talent',
    Interested: 'Interested',
    Favorite: 'Favorite',
    Liked: 'Liked',
    Archive: 'Archived',
};

export default class BiddingTalentStep extends ProjectBiddingWizardStep {
    static slug = 'talent-pool';

    static path = '/talent-pool';

    static StepTitle = 'Talent Pool';
    static StepName = 'Talent';
    // static StepName = 'Shortlist Talent';
    static StepHeader = 'Select individuals from the talent pool';

    static accomplishedForProject(project) {
        if (project.isBYO()) {
            return !project.isFixedFee() || project.hasCompletedProjectScopeCall();
        }
        return project.hasRequestedProposal();
    }

    static iconFor(project) {
        return <i className="tab-icon fas fa-users"/>
    }

    listTypes() {
        if (this.props.project
            || !this.props.project.isService()) {
            return TalentListTypes;
        }

        return TeamListTypes;
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            ...this.state,
            activeListType: this.listTypes().All,
            activeListTypes: {},
            error: null,
            sortBy: this.props.project.matchSort(),

            isLoading: true,
            isLoadingPositions: {},
            matchRequests: {},
            potentialTalent: this.props.project.isBYO() ? TB.tryArray(this.props.project.sortedPositions()) : null,
        };
    }

    shouldCaptureRequests() {
        return true;
    }

    async componentDidMount() {
        super.componentDidMount();

        await this.middlewareCheck(async () => {
            let resetQueryKey = this.props.project.isBYO() ? 'positionMatches' : 'teamMatches';
            await TB.queryClient.removeQueries({
                predicate: ({queryKey}) => queryKey && queryKey[0] === resetQueryKey}
            )
        });
        await this.promisedState({isLoading:false})

    }

    async middlewareCheck(callback = () => true) {
        if (!this._isMounted) return;
        if (!this.context?.auth?.canViewTalentForProject(this.props.project)) {
            await TB.sysAlert('client.tab_visit_project_permission_error');
            await TB.wait(500);

            return this.props.goToStep(BiddingBriefStep);
        }

        if (this.props.project.is_on_hold) {
            await TB.sysAlert('client.tab_visit_disabled_project_on_hold');
            return this.props.goToStep(BiddingBriefStep);
        }
        if (this.props.project.isService()) {

            if (this.props.project.isAwaitingContract()) {
                await TB.sysAlert('team_shopping.teams_tab_visit_sow_status_change');
                return this.props.goToStep(BiddingProposalsStep)
            }
            if (this.props.project.isPendingContract()) {
                await TB.sysAlert('team_shopping.teams_tab_visit_sow_status_change');
                return this.props.goToStep(BiddingContractStep)
            }
        }

        if (this.props.project.isBYO()) {
            if (this.props.project.hasRequestedSOW()) {
                let step = (this.props.project.hasContract()) ? BiddingContractStep : BiddingCandidatesStep;

                await TB.sysAlert('byo.talent_tab_visit_sow_already_requested');
                if (this.props.queryParams?.from) {
                    await TB.wait(200);
                }
                return this.props.goToStep(step)
            }
        }
        return callback()
    }

    async onRequest(request) {
        if (this.props.isDisabled) return;

        await this.props.toggleUsability(false);

        let response = await request();

        await this.props.toggleUsability(true);
        await TB.wait(500);

        return response;
    }

    toggleUsability() {
        this.props.toggleUsability();
    }

    /*
    |--------------------------------------------------------------------------
    | Render Component
    |--------------------------------------------------------------------------
    */
    render() {

        if (this.state.isLoading) {
            return (
                <div className="flex-grow flex flex-col items-stretch justify-start py-10 px-2 sm:px-6">
                        {!this.props.location.pathname.includes('profiles') && this.renderStepHeader()}
                        {!this.props.location.pathname.includes('profiles') &&
                            <hr className="project-bidding-step-divider"/>}

                        <LoadingBanner
                            message={this.props.location.pathname.includes('profiles') ? "Loading" : "Finding Matches"}/>
                </div>
            )
        }

        if (this.state.isLoading) {
            return <LoadingBanner message="Finding Matches"/>
        } else if (this.props.project?.hasRequestedSOW()) {
            return <div className="flex-grow"/>
        }

        return (
            <div className="flex-grow relative flex flex-col flex-1">
                <div className="flex flex-col flex-1 talent-scaling">
                    <div className="flex flex-1 items-stretch relative" id="search-talent-container">


                        <Outlet context={{
                            goToStep: this.props.goToStep,
                            onRequest: this.onRequest.bind(this),
                            listTypes: this.listTypes(),
                            isDisabled: this.props.isDisabled
                        }}/>

                    </div>



                </div>
                {this.props.project.isBYO() && (
                    <React.Fragment>


                        <ShareModal
                            onRequest={this.onRequest.bind(this)}
                            onUpdated={this.refreshTalentFor.bind(this)}
                            disabled={this.props.isDisabled}
                            projectId={this.props.project?.id}
                        />
                        <BiddingPositionNav/>

                        <BulkActionsContainer/>

                    </React.Fragment>
                )}

                {!this.props.project.isBYO() && this.props.project.approved_team_count > 0 && (
                    <ProposalFooter/>
                )}
            </div>
        )

    }
}

const BiddingPositionNav = (props) => {
    const {project, isLoading, requestSOW, bulkActions, onClearBulkActions, onRunBulkActions} = useProject();
    const location = useLocation();
    const {positionId} = useParams();
    const {auth} = useAuth()

    const navigate = useNavigate();
    // How many queries matching the posts prefix are fetching?
    const isFetchingTalent = useIsFetching(['positionMatches'])

    const [loadedMatches, setLoadedMatches] = useState(undefined);


    const positions = useMemo(() => project.sortedPositions(), [project.positions]);
    const currentRoleIndex = useMemo(() => {
        return TB.findIndex(project.sortedPositions(), ['id', parseInt(positionId)]) || 0
    }, [positionId]);

    useEffect(() => {
        if (loadedMatches) return;
        if (isFetchingTalent && loadedMatches === undefined) {
            setLoadedMatches(false)
        } else if (!isFetchingTalent && loadedMatches === false) {
            setLoadedMatches(true)
        }
    }, [isFetchingTalent]);

    if (isLoading || !positionId || location.pathname.includes('profiles')) {
        return null;
    }

    const scrollToPosition = (position_id) => {
        return navigate({
            ...location,
            search: '',
            pathname: `role/${position_id}`
        })
    }

    const hasNextRole = positions[currentRoleIndex + 1];
    const hasPrevRole = currentRoleIndex > 0;

    const totalPositions = project.positions?.length;
    const filledPositions = project.positions.filter(posi => posi.hasBeenFilled());
    const canAuthRequestSOW = auth.canRequestSOWForProject(project);

    return (
        <Affix offsetBottom={-1} style={{zIndex: 99}}>
            <div className="bidding-footer-nav bidding-footer-alt drop-shadow-xl">
                <div className="w-full flex justify-between max-w-[1225px]">
                    <div className="flex items-center gap-x-8 md:gap-x-16">

                        <div className="flex flex-col gap-1">
                            {positions?.length > 0 && (
                                <h6 className="mb-0 text-sm">
                                    Position <b>{currentRoleIndex + 1}</b> of {positions?.length}
                                </h6>
                            )}
                            {positions[currentRoleIndex] && (
                                <div className="flex flex-row flex-no-wrap items-center">
                                    <h5 className="mb-0 mr-3 text-base">
                                        {positions[currentRoleIndex].title}
                                    </h5>

                                    <Link
                                        to={{
                                            ...location,
                                            search: '',
                                            pathname: `role/${positions[currentRoleIndex - 1]?.id}`
                                        }}
                                        className={TB.mapClass("mx-2", {
                                            "pointer-events-none": currentRoleIndex <= 0
                                        })}
                                        onClick={e => {
                                            if (currentRoleIndex <= 0) {
                                                e.preventDefault();
                                            }
                                        }}
                                        disabled={currentRoleIndex <= 0}
                                    >
                                        <i className="fas fa-2x fa-chevron-circle-left"/>
                                    </Link>
                                    <Link
                                        to={{
                                            ...location,
                                            search: '',
                                            pathname: `role/${positions[currentRoleIndex + 1]?.id}`
                                        }}
                                        className={TB.mapClass("mx-2", {
                                            "pointer-events-none": !positions[currentRoleIndex + 1]
                                        })}
                                        onClick={e => {
                                            if (!positions[currentRoleIndex + 1]) {
                                                e.preventDefault();
                                            }
                                        }}
                                        disabled={!positions[currentRoleIndex + 1]}
                                    >
                                        <i className="fas fa-2x fa-chevron-circle-right"/>
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="flex items-center gap-x-8 md:gap-x-16">

                        <div>
                            {filledPositions.length} of {totalPositions} positions filled
                        </div>

                        <div className="hidden md:flex flex-row items-center gap-2">
                            {project.positions && project.positions.map((position, index) => {

                                let hasBeenFilled = position.hasBeenFilled();
                                let talent = {};

                                if (hasBeenFilled && position.assigned_candidate) {
                                    talent = position.assignedCandidate()
                                }

                                let assigned = (hasBeenFilled && talent?.image_path);
                                // let active = parseInt(positionId) === position.id;
                                let key = `pos${position.id}-talent${talent?.id || 'unassigned'}`;

                                let targetPath = position.currentBriefStep();
                                let canNavigate = !location.pathname.includes(targetPath);

                                return (
                                    <div key={key}
                                         className={TB.mapClass("position-swiper-slide", {
                                             assigned,
                                             unassigned: !assigned,
                                             //  active
                                         })}
                                    >
                                        <div
                                            id={key}
                                            className={TB.mapClass("role-img", {
                                                clickable: canNavigate
                                            })}
                                            onClick={(e) => {
                                                if (canNavigate) {
                                                    navigate({
                                                        pathname: `/client/project/bidding/${project?.id}${targetPath}`,
                                                        search: '?from=talent'
                                                    })
                                                }

                                            }}
                                        >
                                            {(hasBeenFilled && talent?.image_path) ? (
                                                <UserImageCircle
                                                    user={talent}
                                                    hideTooltip={true}
                                                    size={50} className="img-fluid img-grayscale"/>
                                            ) : (
                                                <span>
                                                    <i className="fa fa-user-circle"/>
                                                    <span className="position-index">
                                                        {index + 1}
                                                    </span>
                                                </span>
                                            )}
                                        </div>

                                        <InfoTooltip type="dark" placement="bottom" target={key}>
                                            <div className="position-tooltip">
                                                <p>{position.title}</p>
                                                <p>
                                                    {hasBeenFilled ? talent.firstNamePlusInitial?.() : "TBD"}
                                                </p>
                                            </div>
                                        </InfoTooltip>
                                    </div>
                                )
                            })}
                        </div>

                        <div>

                            <button
                                type="button"
                                id="request-sow-btn"
                                onClick={() => {
                                    if (!canAuthRequestSOW) {
                                        return TB.showPermissionError();
                                    }
                                    return requestSOW();
                                }}
                                className={TB.mapClass("btn btn-primary btn-block w-full", {
                                    'disabled-edit-link': !project.hasFilledAllPositions(),
                                })}
                            >
                                Request SOW
                                {!project.hasRequestedSOW() && !canAuthRequestSOW && (
                                    <i className="fa fa-lock ml-1"/>
                                )}
                            </button>

                            {!project.hasFilledAllPositions() && (
                                <InfoTooltip type="gray" placement="bottom" target="request-sow-btn">
                                    <p className="p-0 text-white">All positions must be filled to request SoW</p>
                                </InfoTooltip>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </Affix>
    )
}
const TalentWizardStep = (props) => {
    const {project, isLoading, update} = useProject();

    const [scrollRef, setScrollRef] = useState(null);
    const location = useLocation();
    const {positionId} = useParams();
    const {
        toggleUsability,
        queryParams,
        isDisabled,
        goToStep
    } = useOutletContext();
    let onRequest = async (callback = async () => true) => {
        await toggleUsability(false);
        let response = await callback();
        await toggleUsability(true);
        return response;
    }
    const Wrapper = useMemo(() => {
        if (isLoading || !project?.id || project.isService()) {
            return React.Fragment
        }

        return ProjectPositionProvider
    }, [isLoading, project?.id]);

    if (!project || (
        project.isBYO() && !TB.first(project.sortedPositions())?.id
    )) {
        return null;
    }

    if (!isLoading && project) {
        let talentStepRedirect = null;
        if (project.isBYO() && !positionId) {
            let firstPositionId = TB.first(project.sortedPositions())?.id;
            if (!firstPositionId) return null;

            talentStepRedirect = generatePath(`role/:positionId`, {
                positionId: firstPositionId
            })
        }
        if (project.isService() && !location.pathname.includes('talent-pool/teams')) {
            talentStepRedirect = TB.replace(location.pathname, 'talent-pool', 'talent-pool/teams');
        }
        if (talentStepRedirect) {
            return <Navigate to={{...location, pathname: talentStepRedirect}} replace={true}/>
        }
    }

    return (
        <Wrapper>
            <BiddingTalentStep
                project={project}
                updateProject={update}
                location={location}
                toggleUsability={toggleUsability}
                queryParams={queryParams}
                isDisabled={isDisabled}
                goToStep={goToStep}/>
            {project?.isBYO() && (
                <ProposalRouteModal
                    onRequest={onRequest}
                    onUpdated={() => true}
                    disabled={isDisabled}
                />
            )}
        </Wrapper>
    )
}

const TalentWizardRedirect = (props) => {

    const navigate = useNavigate();
    const location = useLocation();

    if (location.pathname.includes('role-')) {
        const regex = /role-(\d+)?(.*)/gm;

        const str = location.pathname;
        const subst = `role/$1$2`;

        // The substituted value will be contained in the result variable
        const result = str.replace(regex, subst);

        return (
            <Navigate to={{...location, pathname: result}} replace={true}/>
        )
    }
    return <PageNotFound/>
}


export {
    TalentWizardStep,
    TalentWizardRedirect
}

const styles = {
    listTypeDropdown: {
        alignSelf: 'stretch',
        textAlign: 'center',
        border: '1px solid rgb(25, 42, 62)',
        boxSizing: 'border-box',
        fontWeight: 600,
        fontSize: '13px',
        lineHeight: '19px',
        letterSpacing: '0.01em',
        maxWidth: 'none',
    },
};